import React, { useState } from 'react';
import { Page } from '../types';

interface HeaderProps {
  currentPage: Page;
  setCurrentPage: (page: Page) => void;
}

const Header: React.FC<HeaderProps> = ({ currentPage, setCurrentPage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [Page.Home, Page.Pricing, Page.UseCases, Page.About, Page.Contact];

  const NavLink: React.FC<{ page: Page }> = ({ page }) => {
    const isActive = currentPage === page || (currentPage === Page.UseCaseDetail && page === Page.UseCases);
    return (
        <button
          onClick={() => {
            setCurrentPage(page);
            setIsOpen(false);
          }}
          className={`px-4 py-2 text-sm font-medium transition-colors duration-300 relative ${
            isActive
              ? 'text-[#05F564]'
              : 'text-slate-600 dark:text-zinc-400 hover:text-slate-900 dark:hover:text-zinc-100'
          }`}
        >
          {page}
          {isActive && (
            <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-4 h-0.5 bg-[#05F564] rounded-full"></span>
          )}
        </button>
    );
  };


  return (
    <header className="glass-effect shadow-sm sticky top-0 z-40 border-b border-transparent dark:border-zinc-800/50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0">
            <button onClick={() => setCurrentPage(Page.Home)} className="flex items-center space-x-2">
               <span className="text-2xl font-bold text-slate-800 dark:text-zinc-100">Wampia<span className="text-[#05F564]">.</span></span>
            </button>
          </div>
          <div className="hidden md:block">
            <nav className="flex items-center space-x-1">
              {navItems.map(page => <NavLink key={page} page={page} />)}
            </nav>
          </div>
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-slate-600 dark:text-zinc-400 hover:text-slate-900 dark:hover:text-zinc-100 focus:outline-none">
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"} />
              </svg>
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="md:hidden glass-effect border-t border-slate-200 dark:border-zinc-800">
          <nav className="px-2 pt-2 pb-3 space-y-1 sm:px-3 flex flex-col items-center">
            {navItems.map(page => <NavLink key={page} page={page} />)}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;